<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">即时开奖</span>
        </div>
        <div v-if="hasLeftTabbar" class="c8-menubox">
          <div class="c8-menubox__btnbox">
            <a
              v-for="(item, index) in menuBox"
              :key="index"
              class="button-outline c8-menubox__btnbox__item"
              :class="{active: item.active}"
              @click="item.active = !item.active"
            >
              <span class="button-outline__text">{{ item.name }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <div v-if="hasRightTabbar" class="c8-datebox">
          <a class="button-outline c8-datebox__item" @click="resetHaoMaJhuShou">
            <span class="button-outline__text">历史开奖</span>
          </a>
        </div>
        <div v-else>
          <LotteryDateFilterTab @updateForm="chooseDate" />
        </div>
      </div>
    </div>
    <!-- 今日雙面統計 -->
    <transition name="layout" mode="out-in">
      <component
        :is="shuangMianTonJi"
        v-if="hasJinRiShuangMian"
        :lottery-code="lotteryCode"
        :lottery-type="lotteryType"
      />
    </transition>
    <!-- 今日長龍統計 -->
    <transition name="layout" mode="out-in">
      <JinRiChangLongTongJi v-if="hasJinRiChangLong" :lottery-code="lotteryCode" />
    </transition>
    <!-- 號碼助手 -->
    <transition name="layout" mode="out-in">
      <HaoMaJhuShou
        v-if="hasHaoMaJuShou"
        :lottery-type="lotteryType"
      />
    </transition>
    <!-- 即時開獎 -->
    <transition name="tab" mode="out-in">
      <component
        :is="kaiJiangTable"
        ref="KaiJiangTable"
        :lottery-code="lotteryCode"
        :period-format="periodFormat"
        :lottery-type="lotteryType"
      />
    </transition>
  </div>
</template>

<script>
import Pk10Kl10ShuangMianTonJi from '@/components/web/pages/trend/JiShihKaiJiang/Pk10Kl10ShuangMianTonJi'
import Ssc11x5ShuangMianTonJi from '@/components/web/pages/trend/JiShihKaiJiang/Ssc11x5ShuangMianTonJi'
import JinRiChangLongTongJi from '@/components/web/pages/trend/JiShihKaiJiang/JinRiChangLongTongJi'
import HaoMaJhuShou from '@/components/web/pages/trend/JiShihKaiJiang/HaoMaJhuShou'
import k3KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/k3'
import kl8KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/kl8'
import xy28KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/xy28'
import othersKaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/others'
import KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable'
import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
export default {
  name: 'JiShihKaiJiang',
  components: {
    Pk10Kl10ShuangMianTonJi,
    Ssc11x5ShuangMianTonJi,
    JinRiChangLongTongJi,
    k3KaiJiangTable,
    kl8KaiJiangTable,
    xy28KaiJiangTable,
    othersKaiJiangTable,
    KaiJiangTable,
    HaoMaJhuShou,
    LotteryDateFilterTab
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      menuBox: [
        { name: '今日双面统计', active: false },
        { name: '今日长龙统计', active: false },
        { name: '号码助手', active: false }
      ],
      lotteryCode: this.$route.params.lottery_code,
      shuangMianTonJi: null,
      kaiJiangTable: null,
      periodFormat: {
        count: '30',
        date: undefined,
        year: undefined
      }
    }
  },
  computed: {
    isGaopinLottery() {
      return this.lotteryType !== 'others' || this.lotteryCode === 'shssc'
    },
    hasMultiStatsLotteries() {
      return this.lotteryType === 'pk10' || this.lotteryType === 'kl10' || this.lotteryType === '11x5' || this.lotteryType === 'ssc'
    },
    hasLeftTabbar() {
      return this.hasMultiStatsLotteries
    },
    hasRightTabbar() {
      return this.isGaopinLottery
    },
    hasJinRiShuangMian() {
      return this.menuBox[0].active
    },
    hasJinRiChangLong() {
      return this.menuBox[1].active
    },
    hasHaoMaJuShou() {
      return this.menuBox[2].active
    }
  },
  mounted() {
    if (this.lotteryType === '11x5' || this.lotteryType === 'ssc') {
      this.menuBox[0].name = '今日双面/号码统计'
    }
    this.getshuangMianTonJi()
    this.getKaiJiangTable()
  },
  methods: {
    getshuangMianTonJi() {
      switch (this.lotteryType) {
        case 'pk10':
        case 'kl10':
          this.shuangMianTonJi = Pk10Kl10ShuangMianTonJi
          break
        case 'ssc':
        case '11x5':
          this.shuangMianTonJi = Ssc11x5ShuangMianTonJi
          break
      }
    },
    getKaiJiangTable() {
      switch (this.lotteryType) {
        case 'k3':
          this.kaiJiangTable = k3KaiJiangTable
          break
        case 'kl8':
          this.kaiJiangTable = kl8KaiJiangTable
          break
        case 'xy28':
          this.kaiJiangTable = xy28KaiJiangTable
          break
        case 'others':
          this.kaiJiangTable = othersKaiJiangTable
          break
        default:
          this.kaiJiangTable = KaiJiangTable
          break
      }
    },
    chooseDate(form) {
      Object.assign(this.periodFormat, form)
    },
    resetHaoMaJhuShou() {
      this.$router.push(`/lottery/trend/${this.lotteryCode}?trendType=LiShihKaiJiang`)
      this.$store.commit('lottery/RESET_ACTIVE_LIST')
    }
  }
}
</script>
